var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportIncident(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5207_17884",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5207_17884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 19.5V16.5H33.5V19.5H27.5ZM29.3 30L24.5 26.4L26.3 24L31.1 27.6L29.3 30ZM26.3 12L24.5 9.6L29.3 6L31.1 8.4L26.3 12ZM8 28.5V22.5H6.5C5.675 22.5 4.96875 22.2063 4.38125 21.6188C3.79375 21.0313 3.5 20.325 3.5 19.5V16.5C3.5 15.675 3.79375 14.9688 4.38125 14.3813C4.96875 13.7938 5.675 13.5 6.5 13.5H12.5L20 9V27L12.5 22.5H11V28.5H8ZM21.5 23.025V12.975C22.175 13.575 22.7188 14.3063 23.1313 15.1688C23.5438 16.0313 23.75 16.975 23.75 18C23.75 19.025 23.5438 19.9687 23.1313 20.8312C22.7188 21.6937 22.175 22.425 21.5 23.025Z",
    fill: "#004EA8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIncident);
export default __webpack_public_path__ + "static/media/reportIncident.a294356c3d349e9e8a57f9b88bdf832d.svg";
export { ForwardRef as ReactComponent };